import React from 'react';
import { ItemHeadUser } from '../ItemHeadUser';
import { ItemUser } from '../ItemUser';
import './TableUser.css';

export function TableUser(props) {
  
    const { users, onReload } = props;
  
    return (
        <>
            <div className='table-user'>
                <table>
                    <ItemHeadUser />

                    {users.map((user) => (
                        <ItemUser key={user._id} user={user} onReload={onReload} />
                    ))}
                </table>
            </div>
        </>
  )
}
